/* Actions.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJnO1v%7Bgrid-area%3Aactions%7D%0A%40media%7B._1bTkgF5zaO%7Bmargin-block-start%3Avar(--ds-space-200%2C1pc)%7D%7D%0A%40media%20(min-width%3A48rem)%7B._4G9GKtIZbP%7Bmargin-inline-start%3Aauto%7D._1lZLzUZqHV%7Bmargin-block-start%3Aunset%7D%7D");


import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled/inline';
const compiledStyles = {
  root: "_1xC2CJnO1v _1bTkgF5zaO _4G9GKtIZbP _1lZLzUZqHV"
};
export const Actions = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return <Inline space="space.100" xcss={compiledStyles.root} shouldWrap>
			{children}
		</Inline>;
};